// extracted by mini-css-extract-plugin
export default {"background":"YZiCexi67minHt_E62Da","modal":"kQb6oWf4DO8Dkxexhqhg","head":"UJAbZXG20HIQRCe14TaJ","body":"xP6pDeAbXvgnr1oiNQet"};